import { render, staticRenderFns } from "./HealthRiskFactors.vue?vue&type=template&id=3a0730a2&scoped=true"
import script from "./HealthRiskFactors.vue?vue&type=script&lang=js"
export * from "./HealthRiskFactors.vue?vue&type=script&lang=js"
import style0 from "./HealthRiskFactors.vue?vue&type=style&index=0&id=3a0730a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0730a2",
  null
  
)

export default component.exports